/* Bijverkoop in winkelwagen (Shaped4)
   Voegt het gekozen product toe met het verborgen kenmerk _upsell
   en ververst de winkelwagen via de bestaande mini-cart.renderContents(). */
if (!customElements.get('cart-upsell-item')) {
  class CartUpsellItem extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-upsell-add]');
      this.select = this.querySelector('.cart-upsell__select');
      this.error = this.querySelector('.cart-upsell__error');
      if (!this.button) return;

      if (this.select) {
        this.updateButton();
        this.select.addEventListener('change', () => this.updateButton());
      }
      this.button.addEventListener('click', (event) => this.add(event));
    }

    updateButton() {
      this.button.disabled = !this.select.value;
    }

    getVariantId() {
      return this.select ? this.select.value : this.dataset.variantId;
    }

    async add(event) {
      event.preventDefault();
      const variantId = this.getVariantId();
      if (!variantId) return;

      this.button.disabled = true;
      this.classList.add('is-loading');
      if (this.error) this.error.hidden = true;

      const miniCart = document.querySelector('mini-cart');
      const sections = miniCart && typeof miniCart.getSectionsToRender === 'function'
        ? miniCart.getSectionsToRender().map((section) => section.section)
        : ['mini-cart'];
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1, properties: { _upsell: 'true' } }],
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Toevoegen mislukt');
        }

        if (miniCart && data.sections) {
          miniCart.renderContents(data);
        } else {
          window.location.reload();
        }
      } catch (error) {
        console.error(error);
        if (this.error) {
          this.error.textContent = error.message;
          this.error.hidden = false;
        }
        this.button.disabled = false;
        this.classList.remove('is-loading');
      }
    }
  }

  customElements.define('cart-upsell-item', CartUpsellItem);
}